// @ts-check
import { Flex } from '@adobe/react-spectrum';
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import { handleProfileForLaunch } from '@exchange-frontends/utils';

const ProfileContainer = styled.div`
  padding: 40px 32px;
  margin: 0 auto;
  max-width: 1280px;
  /* 1280 + 24 + 24 = 1328, therefore < 1329 needs padding */
  @media screen and (max-width: 1329px) {
    padding: 40px 24px;
  }
`;

/**
 * @param {object} props
 * @param {object} props.children
 * @param {object} [props.data]
 * @param {string} [props.publisherLogo]
 */
export const ProfileLayout = ({ data, children, publisherLogo }) => {
  return (
    <ProfileContainer onClickCapture={handleProfileForLaunch}>
      <Helmet>
        <title>{`${data?.name ?? ''} | Adobe Exchange`}</title>
        <meta name="robots" content="noodp, FOLLOW, INDEX" />
        <meta name="title" content={`${data?.name ?? ''} | Adobe Exchange`} />
        <meta property="og:title" content={`${data?.name ?? ''} | Adobe Exchange`} />
        <meta name="description" content={data?.description} />
        <meta property="og:description" content={data?.description} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={data?.logo ? data.logo : publisherLogo} />
        <meta name="thumbnailUrl" content={data?.logo ? data.logo : publisherLogo} />
        <meta name="keywords" content="" />
      </Helmet>
      <Flex data-testingid="publisher-profile" minHeight="100vh" direction="column" alignItems="stretch">
        {children}
      </Flex>
    </ProfileContainer>
  );
};
